import "./6caf66dc6e1da6a84e2be75d41846ce0.css";
export default {"header":"_OQbRB"};